import { isExists } from 'date-fns'

export const identificationToDate = (identification: string) => {
  let year = parseInt(identification.substring(0, 2), 10)
  let month = parseInt(identification.substring(2, 4), 10) - 1
  let day = parseInt(identification.substring(4, 6), 10)
  switch (parseInt(identification.substring(2, 3), 10)) {
    case 2:
    case 3:
      month -= 20
      year += 2000
      break
    case 4:
    case 5:
      month -= 40
      year += 2100
      break
    case 6:
    case 7:
      month -= 60
      year += 2200
      break
    case 8:
    case 9:
      month -= 80
      year += 1800
      break
    default:
      year += 1900
  }
  return isExists(year, month, day) ? new Date(year, month, day) : null
}
